var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { API_GET_USER_PROFILE, API_UPDATE_USER_PROFILE } from "../../api";
export const updateProfile = (api, data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.put(API_UPDATE_USER_PROFILE, data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 503) {
                throw new Error("you are not allowed to update profile");
            }
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("user profile not found");
            }
        }
        throw new Error("server error");
    }
});
export const clearProfile = (api) => __awaiter(void 0, void 0, void 0, function* () {
    throw new Error("not implemented");
});
export const getProfile = (api, address) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_USER_PROFILE + address);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("user profile not found");
            }
        }
        throw new Error("server error");
    }
});
//# sourceMappingURL=profile.utils.js.map